<template>
    <div
      class="modal modal-bottom fade"
      id="bottom_modal_memorize"
      tabindex="-1"
      role="dialog"
      aria-labelledby="bottom_modal_memorize_title"
      style="z-index: 10000"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content mbr-memo">
                <div class="mbr-memo__top">
                    <span class="mbr-memo__handle" aria-hidden="true"></span>
                    <button type="button" class="mbr-memo__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
                        <i class="material-icons-round" aria-hidden="true">close</i>
                    </button>
                </div>
                <div class="mbr-memo__body">
                    <span class="mbr-memo__emblem" aria-hidden="true">
                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
                            <rect height="11" rx="2" ry="2" width="18" x="3" y="11" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            <circle cx="12" cy="16" fill="currentColor" r="1.2" />
                        </svg>
                    </span>
                    <p id="bottom_modal_memorize_title" class="mbr-memo__text">
                        <span>{{ $t('memorize.line1') }}</span><br />
                        <span>{{ $t('memorize.line2') }}</span><br />
                        <span>{{ $t('memorize.line3') }}</span>
                    </p>

                    <!-- <div class="text-center text-size-18 mt-4" style="color: #222">
                        <span>DD/MM/YYYY</span>
                    </div>

                    <div class="text-center text-size-18 mt-4" style="color: orange">
                        <strong>{{ birthday }}</strong>
                    </div> -->

                    <!-- <div class="text-center mt-4">
                        <a @click="changePasscode()" data-bs-dismiss="modal" aria-label="Close" class="text-decoration-underline text-info">Change passcode</a>
                    </div> -->
                </div>
                <material-button size="lg" full-width @click="changePasscode()" data-bs-dismiss="modal">
                    {{ $t('memorize.reset') }}
                </material-button>
                <button
                    class="bottom_modal_memorize"
                    style="display: none"
                    data-bs-toggle="modal"
                    data-bs-target="#bottom_modal_memorize"
                >
                    Show Model
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
    import MaterialButton from "@/components/MaterialButton.vue";
    import router from "@/router";
    import moment from 'moment';
    import { localStorageName, getMerchantCode } from "@/config/utils";

    export default {
        name: "MemorizeYourBirthday",
        components: {
            MaterialButton
        },
    props: {
      
    },
    data() {
        return {
            merchantCode: "",
            branchCode: "",
            birthday: 'N/A',
        };
    },
    mounted() {
        const user = JSON.parse(localStorage.getItem(localStorageName("member")));
        if(user && user.data && user.data.user && user.data.user.date_of_birth != "") {
            this.birthday = moment(user.data.user.date_of_birth).format('DD/MM/YYYY');
        }

        const merchantCode = getMerchantCode();
        this.merchantCode = merchantCode ? `/${merchantCode}` : "";
        const branchCode = localStorage.getItem(localStorageName("BRANCH_CODE"), "");
        this.branchCode = branchCode ? `/${branchCode}` : "";
    },
    methods: {
        changePasscode() {
            router.push(this.merchantCode + this.branchCode+"/change-passcode");
        },
        handleOk() {
            var currentUrl = window.location.href;
            var baseUrl = currentUrl.split('?')[0];
            window.location.href = baseUrl;
        }
    },
  };
  </script>
  <style scoped>
  /* MBR023: same bottom sheet as ModalConfirmDeactivateMember (MBR082).
     Doubled with .modal.modal-bottom to outrank the square corners set below */
  .modal.modal-bottom .modal-content.mbr-memo {
    padding: 12px 24px 28px;
    background: var(--mbr-color-canvas);
    border: 0;
    border-radius: 28px 28px 0 0;
    box-shadow: var(--mbr-shadow-modal);
    font-family: var(--mbr-font-body);
  }

  .mbr-memo__top {
    position: relative;
    display: flex;
    justify-content: flex-end;
    min-height: 36px;
  }

  .mbr-memo__handle {
    position: absolute;
    top: 0;
    left: 50%;
    width: 40px;
    height: 4px;
    background: var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    transform: translateX(-50%);
  }

  .mbr-memo__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    color: var(--mbr-color-ink-headline);
  }

  .mbr-memo__close .material-icons-round {
    font-size: 20px;
  }

  .mbr-memo__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4px 0 24px;
    text-align: center;
  }

  .mbr-memo__emblem {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
    background: var(--mbr-color-peach);
    border: 2px solid rgba(var(--mbr-color-gold-rgb), 0.5);
    border-radius: var(--mbr-radius-full);
    color: var(--mbr-color-primary);
  }

  .mbr-memo__emblem svg {
    width: 28px;
    height: 28px;
  }

  .mbr-memo__text {
    margin: 0;
    font-family: var(--mbr-font-headline);
    font-size: var(--mbr-headline-sm-size);
    font-weight: var(--mbr-headline-sm-weight);
    line-height: 26px;
    color: var(--mbr-color-ink-headline);
  }

  .bg-term {
    width: 350px;
    height: 45px;
    border-radius: 50px;
  }
  .bg-color-common {
    color: #fff;
  }
  .img-terms {
    max-width: 700px;
  }
  
  /* Css model */
  .modal.modal-left .modal-dialog,
  .modal.modal-right .modal-dialog,
  .modal.modal-top .modal-dialog,
  .modal.modal-bottom .modal-dialog {
    -webkit-transform: translate3d(0%, 0, 0);
    -ms-transform: translate3d(0%, 0, 0);
    -o-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }
  
  /* Left & Right */
  
  .modal.modal-left .modal-dialog,
  .modal.modal-right .modal-dialog {
    position: fixed;
    margin: auto;
    width: 500px;
    max-width: 100%;
    height: 100%;
  }
  
  .modal.modal-left .modal-content,
  .modal.modal-right .modal-content {
    height: 100%;
    overflow-y: auto;
  }
  
  .modal.modal-left .modal-body,
  .modal.modal-right .modal-body {
    padding: 15px 15px 80px;
  }
  
  .modal.modal-left.fade .modal-dialog {
    left: -500px;
    -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
    -o-transition: opacity 0.3s linear, left 0.3s ease-out;
    transition: opacity 0.3s linear, left 0.3s ease-out;
  }
  
  .modal.modal-left.fade.show .modal-dialog {
    left: 0;
  }
  
  .modal.modal-right.fade .modal-dialog {
    right: -500px;
    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
    -o-transition: opacity 0.3s linear, right 0.3s ease-out;
    transition: opacity 0.3s linear, right 0.3s ease-out;
  }
  
  .modal.modal-right.fade.show .modal-dialog {
    right: 0;
  }
  
  .modal.modal-left .modal-content,
  .modal.modal-right .modal-content,
  .modal.modal-top .modal-content,
  .modal.modal-bottom .modal-content,
  .modal.modal-full .modal-content {
    border-radius: 0;
    border: none;
  }
  
  .modal.modal-left .modal-dialog.modal-sm,
  .modal.modal-right .modal-dialog.modal-sm {
    width: 300px;
  }
  
  .modal.modal-left .modal-dialog.modal-lg,
  .modal.modal-right .modal-dialog.modal-lg {
    width: 800px;
  }
  
  .modal.modal-left .modal-dialog.modal-xl,
  .modal.modal-right .modal-dialog.modal-xl {
    width: 1140px;
  }
  
  /* Top and Bottom */
  
  .modal.modal-top .modal-dialog,
  .modal.modal-bottom .modal-dialog {
    position: fixed;
    margin: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  
  .modal.modal-top .modal-content,
  .modal.modal-bottom .modal-content {
    height: auto;
    overflow-y: auto;
  }
  
  .modal.modal-top .modal-body,
  .modal.modal-bottom .modal-body {
    padding: 15px 15px;
  }
  
  /* Top */
  
  .modal.modal-top.fade .modal-dialog {
    top: -100%;
    -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
    -o-transition: opacity 0.3s linear, top 0.3s ease-out;
    transition: opacity 0.3s linear, top 0.3s ease-out;
  }
  
  .modal.modal-top.fade.show .modal-dialog {
    top: 0;
  }
  
  /* Bottom */
  
  .modal.modal-bottom.fade .modal-dialog {
    bottom: -100%;
    -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    transition: opacity 0.3s linear, bottom 0.3s ease-out;
  }
  
  .modal.modal-bottom.fade.show .modal-dialog {
    bottom: 0;
  }
  
  .modal.modal-bottom.fade .modal-dialog {
    bottom: -100%;
  }
  
  /* Full Screen */
  
  .modal.modal-full .modal-dialog {
    position: fixed;
    margin: auto;
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
  
  .modal.modal-full .modal-content {
    height: 100%;
    overflow-y: auto;
  }
  
  .modal.modal-full .close-modal {
    position: fixed;
    top: 0;
    right: 3rem;
  }
  
  /* Footer */
  
  .modal-footer-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: var(--mbr-color-surface);
    border-radius: 0;
  }
  
  /* XS */
  
  .modal.modal-left.xs .modal-body,
  .modal.modal-right.xs .modal-body {
    padding: 15px;
  }
  
  
  </style>
  